__turbopack_context__.v({
  "wrapper": "EventTitle-module-scss-module__Jsqjma__wrapper",
});
